(() => {
 'use strict';
 if(window.SolsticePassage||window.Shopify?.designMode||window.SolsticeConversionConfig?.designMode)return;
 if(location.protocol!=='https:'||!['solsticebijoux.com','www.solsticebijoux.com','0ai7i3-i7.myshopify.com'].includes(location.hostname))return;
 const mode=document.currentScript?.dataset?.passageMode||'off';
 if(!['internal-v1','live-v1'].includes(mode)||(mode==='internal-v1'&&window.SolsticeInternalTraffic?.active!==true))return;
 if(/\/(checkouts?|account|orders|authentication|challenge)(?:\/|$)/i.test(location.pathname))return;
 const parameter='_solstice_passage',uuid=v=>typeof v==='string'&&/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/.test(v);
 let reference=null,sequence=0,generation=0,added=false,timer=null,publishTimer=null,expires=0;
 const initial=new URL(location.href),values=initial.searchParams.getAll(parameter),incoming=values.length===1&&uuid(values[0]);
 if(initial.searchParams.has('_solstice_p2'))return;
 if(values.length>1||(values.length===1&&!incoming))return;
 const allowed=()=>{try{return Shopify.customerPrivacy.analyticsProcessingAllowed()===true&&Shopify.customerPrivacy.marketingAllowed()===true;}catch{return false;}};
 function remove(){
  if(!added||!reference)return;
  const url=new URL(location.href);if(url.searchParams.getAll(parameter).length===1&&url.searchParams.get(parameter)===reference){url.searchParams.delete(parameter);history.replaceState(history.state,'',url.href);}
  added=false;
 }
 function publish(){
  if(!allowed()||typeof window.Shopify?.analytics?.publish!=='function'||!reference)return false;
  try{const marker=reference,epoch=generation,result=Shopify.analytics.publish('solstice_passage_page',{version:1,page_instance_id:reference,seq:sequence++,surface:'web'});
   if(result&&typeof result.then==='function')result.then(ok=>{if(ok===false&&epoch===generation&&reference===marker)remove();},()=>{if(epoch===generation&&reference===marker)remove();});
   return result!==false;}catch{return false;}
 }
 function nudge(epoch,left=4){
  if(publishTimer!==null||left===0)return;
  publishTimer=setTimeout(()=>{publishTimer=null;if(epoch!==generation||!allowed()||incoming)return;publish();nudge(epoch,left-1);},1000);
 }
 function start(){
  if(!allowed())return;
  if(incoming){reference=values[0];return;}
  if(reference&&Date.now()>=expires){remove();reference=null;sequence=0;}
  if(!reference){reference=globalThis.crypto?.randomUUID?.();expires=Date.now()+300000;}if(!uuid(reference)||!publish())return;
  const url=new URL(location.href);if(url.searchParams.has(parameter))return;
  url.searchParams.set(parameter,reference);history.replaceState(history.state,'',url.href);added=true;nudge(generation);
 }
 function refresh(){
  generation++;if(timer!==null)clearTimeout(timer);timer=null;if(publishTimer!==null)clearTimeout(publishTimer);publishTimer=null;
  if(!allowed()){remove();reference=null;sequence=0;return;}
  wait(generation,0);
 }
 document.addEventListener('visitorConsentCollected',refresh);
 window.addEventListener('pageshow',()=>{if(allowed())start();});
 function wait(epoch,tries){
  timer=null;if(epoch!==generation)return;
  if(allowed()&&typeof window.Shopify?.analytics?.publish==='function'){start();return;}
  if(tries<9)timer=setTimeout(()=>wait(epoch,tries+1),500);
 }
 wait(generation,0);
 window.SolsticePassage=Object.freeze({version:'1.0.0',mode});
})();
